import { Component, Inject, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

export interface IterationItem {
  id: string | number;
  label: string;
  selected?: boolean;
}

export interface IterationsDialogData {
  title?: string;
  primaryText?: string;
  iterations: IterationItem[];
  confirmText?: string;
  cancelText?: string;
  singleSelect?: boolean;
  showFormulationOption?: boolean;
}

export interface IterationsDialogResult {
  iterations: IterationItem[] | IterationItem;
  showFormulation: boolean;
}

@Component({
  selector: 'app-iterations-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule],
  templateUrl: './iterations-dialog.component.html',
  styleUrls: ['./iterations-dialog.component.scss']
})
export class IterationsDialogComponent {
  @Output() confirmed = new EventEmitter<IterationItem[] | IterationItem>();

  iterations: IterationItem[] = [];
  title = 'Select Iterations';
  primaryText = '';
  confirmText = 'OK';
  cancelText = 'Cancel';
  singleSelect = false;
  showFormulationOption = false;
  showFormulation = false;
  selectedId: string | number | null = null;

  constructor(
    public dialogRef: MatDialogRef<IterationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IterationsDialogData
  ) {
    if (data) {
      this.title = data.title ?? this.title;
      this.primaryText = data.primaryText ?? this.primaryText;
      this.confirmText = data.confirmText ?? this.confirmText;
      this.cancelText = data.cancelText ?? this.cancelText;
      this.iterations = (data.iterations || []).map(i => ({ ...i }));
      this.singleSelect = !!data.singleSelect;
      this.showFormulationOption = !!data.showFormulationOption;
    }

    if (this.singleSelect && this.iterations.length > 0) {
      const firstSelected = this.iterations.find(i => i.selected);
      this.selectedId = firstSelected ? firstSelected.id : this.iterations[0].id;
    }
  }

  get hasSelection(): boolean {
    if (this.singleSelect) {
      return this.selectedId !== null && this.selectedId !== undefined && this.selectedId !== '';
    }
    return !!(this.iterations && this.iterations.length && this.iterations.some(i => !!i.selected));
  }

  toggleAll(checked: boolean) {
    if (this.singleSelect) return;
    this.iterations.forEach(i => (i.selected = checked));
  }

  onConfirm() {
    if (this.singleSelect) {
      const selected = this.iterations.find(i => i.id === this.selectedId) ?? null;
      if (selected) {
        this.confirmed.emit(selected);
        this.closeSelection(selected);
        return;
      }
      this.dialogRef.close(null);
      return;
    }

    const selectedItems = this.iterations.filter(i => i.selected);
    this.confirmed.emit(selectedItems);
    this.closeSelection(selectedItems);
  }

  onCancel() {
    this.dialogRef.close();
  }

  private closeSelection(selection: IterationItem[] | IterationItem): void {
    if (this.showFormulationOption) {
      this.dialogRef.close({
        iterations: selection,
        showFormulation: this.showFormulation
      } as IterationsDialogResult);
      return;
    }

    this.dialogRef.close(selection);
  }
}
